import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Stack,
  Box,
} from "@mui/material";
import { Bolt, Article, Check } from "@mui/icons-material";
import { borderColors, ColorsConstants } from "../../cssUtils/constants";
import typography from "../../cssUtils/typography";
import ButtonOne from "../../common/normal-button";
import ButtonTwo from "../../common/dashboard-button";
import AppChip from "../../common/app-chip";

const RCSCampaignTypeModal = ({
  open,
  onClose,
  campaignType,
  setCampaignType,
  onQuickSelect,
  onStandardSelect,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: "12px", p: 1 },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Typography sx={{ ...typography.h1 }}>
          Create RCS Campaign
        </Typography>
        <Typography sx={{ ...typography.bodyLarge, mt: 1 }}>
          Choose how you'd like to send this campaign
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Stack sx={{ mt: 2 }} gap={2}>
          {/* Quick */}
          <Box
            onClick={() => setCampaignType("quick")}
            sx={{
              p: 2,
              borderWidth: 2,
              borderColor:
                campaignType === "quick"
                  ? ColorsConstants.primaryBlue90
                  : borderColors.cardBorderPrimaryGrayColor,
              borderRadius: 2,
              borderStyle: "solid",
              cursor: "pointer",
            }}
          >
            <Stack gap={2}>
              <AppChip icon={<Bolt />} color="warning" label="Quick Campaign" />
              <Typography sx={typography.h2}>
                Send to a Single Contact
              </Typography>
              <Typography sx={typography.bodyLarge}>
                Skip setup and broadcast instantly to one person.
              </Typography>
              <Stack direction="row" gap={2}>
                <AppChip icon={<Check />} variant="outlined" color="success" label="No name needed" />
                <AppChip icon={<Check />} variant="outlined" color="success" label="Instant send" />
                <AppChip icon={<Check />} variant="outlined" color="success" label="Single contact" />
              </Stack>
            </Stack>
          </Box>

          {/* OR Divider */}
          <Stack direction="row" alignItems="center" gap={2}>
            <hr style={{ flex: 1 }} />
            <Typography sx={typography.bodyLarge}>or</Typography>
            <hr style={{ flex: 1 }} />
          </Stack>

          {/* Standard */}
          <Box
            onClick={() => setCampaignType("standard")}
            sx={{
              p: 2,
              borderWidth: 2,
              borderColor:
                campaignType === "standard"
                  ? ColorsConstants.primaryBlue90
                  : borderColors.cardBorderPrimaryGrayColor,
              borderRadius: 2,
              borderStyle: "solid",
              cursor: "pointer",
            }}
          >
            <Stack gap={2}>
              <AppChip icon={<Article />} color="primary" label="Standard Campaign" />
              <Typography sx={typography.h2}>
                Full Broadcast Campaign
              </Typography>
              <Typography sx={typography.bodyLarge}>
                Named campaign with segmentation, scheduling & analytics
              </Typography>
              <Stack direction="row" gap={2}>
                <AppChip icon={<Check />} variant="outlined" color="primary" label="Bulk audience" />
                <AppChip icon={<Check />} variant="outlined" color="primary" label="Scheduled sends" />
                <AppChip icon={<Check />} variant="outlined" color="primary" label="Analytics" />
              </Stack>
            </Stack>
          </Box>
        </Stack>
      </DialogContent>

      <DialogActions sx={{ p: 3 }}>
        <ButtonTwo onClick={onClose} title="Cancel" />
        <ButtonOne
          title="Next"
          disabled={!campaignType}
          onClick={() => {
            if (campaignType === "quick") onQuickSelect();
            if (campaignType === "standard") onStandardSelect();
          }}
        />
      </DialogActions>
    </Dialog>
  );
};

export default RCSCampaignTypeModal;